<template>
  <div>
  
  
  <v-container>
    <h2  class="d-flex justify-center mb-6">Generación de Usuarios Random</h2>
    <p  class="d-flex justify-center ">Esta aplicación está hecha con Vue.js . Es un PWA (Progressive Web App). Se conecta a la API de RandomUser . Utilizo Vuetify para los estilos. En el icono del ojo se pueden ver los datos de cada usuario, asi como un mapa de su ubicación. Se puede filtrar por nacionalidad, sexo y edad. Se puede seleccionar los usuarios favoritos y descargar una lista de ellos y sus datos.</p>
    <carrusel/>
<v-btn block elevation="5" color="primary" large @click="getPersons"
    >Generar Consulta</v-btn
  >
  
  <v-data-table
    :headers="headers"
    :items="persons"
    :items-per-page="10"
    class="elevation-19"
    :search="search" 
    
  

  >
     <template v-slot:[`item.Foto`]="{ item }">
         
            <v-img :src="item.picture.thumbnail" max-width="50" max-height="50" />
    
      </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn icon color="indigo">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-eye-circle-outline
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:[`body.append`]>
    <v-row>
      <v-col>
        <v-text-field
          v-model="nat"
          type="string"
          label="Nationality"
        ></v-text-field>
      </v-col>
      <v-col>        
        <v-text-field
          v-model="age"
          type="number"
          label="Age"
        ></v-text-field>
      </v-col>
      <v-col>
         <v-text-field
          v-model="genre"
          type="string"
          label="Genre"
          :items="genre"
        ></v-text-field>
      </v-col> 
        
    </v-row>
    
  </template>
  

  </v-data-table>
   <v-btn color="secondary" elevation="2" @click="openVista3"
    >
    <v-icon>mdi-heart</v-icon>
    Ver Favoritos</v-btn
  >
  </v-container>
  

  <vista-2
    v-if="modal"
    :visible="vista_2"
    :perfil="selected"
    @close="closeItem"
  />
 
  <vista-3 v-if="vista_3" @closeVista3="closeVista3" />
  <footer-eze/>
  </div>
  
</template>
<script>
import axios from "axios";
import Vista2 from "./Vista2.vue";
import Vista3 from "./Vista3.vue";
import FooterEze from "./FooterEze.vue";
import Carrusel from "./Carrusel.vue";

export default {
  components: { Vista2, Vista3, FooterEze , Carrusel},
  data() {
    return {
      headers: [
      {
          text:"Foto",
          value: "Foto"
         },
         {
          text: "Gender",
          align: "start",
          sortable: false,
          value: "gender",
          filter: word => { return ( word + '' ).toLowerCase().includes( this[ 'genre' ].toLowerCase() ) }
        },
        { text: "Name", value: "name.first" },
        { text: "Lastname", value: "name.last" },
        { text: "Email", value: "email" },
        { text: "Nat", value: "nat" , filter: word => { return ( word + '' ).toLowerCase().includes( this[ 'nat' ].toLowerCase() ) }},
        { text: "Date of bird", value: "dob.date",},
        { text: "Age", value: "dob.age", filter: value => {
              if (!this.age) return true

              return value == parseInt(this.age)
            } },
        { text: "Registered", value: "registered.date" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        name: "",
        email: "",
        nat: "",
        dob: "",
        registered: "",
      },
      persons: [],
      url: "https://randomuser.me/api/",
      error_mesage: "",
      search: "",
      nat:"",
      age:"",
      genre: "",
      // seleccionado: "",
      selected: [],
      modal: false,
      vista_2: true,
      vista_3: false,

    };
  },
  computed: {
  
  },
  created() {
    // this.selected();
  },
  methods: {
    getPersons() {
      axios
        .get(this.url + "?results=100")
        .then((result) => {
          console.log(result);
          this.persons = result.data.results;
        })
        .catch((error) => {
          console.log(error);
          this.error_mesage = true;
        });
    },
    // selected() {
    //   this.seleccionado = this.$refs.seleccionado.value;
    // },

    editItem(item) {
      this.editedIndex = this.persons.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      this.selected = Object.assign({}, item);
      this.modal = true;
    },
    closeItem() {
      this.modal = false;
    },
    openVista3() {
      this.vista_3 = true;
      console.log(this.vista_3);
    },
    closeVista3() {
      this.vista_3 = false;
    },
   
  },
};
</script>
